import React from "react";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import ClinetsLogoSlider from "../../Components/home/ClientsLogoSlider";
import { Helmet } from "react-helmet";

const DiwaliCatalog =()=>{
    const CTAContent = [
        {
          pageName: "Diwali Catalog",
          paragraphitalic: "",
          paragraphText:
            "Celebrate the spirit of Diwali with our premium corporate gifting range! From delectable gourmet treats to luxurious hampers, our thoughtfully curated selection is perfect for expressing gratitude and strengthening business bonds. Whether for clients, employees, or partners, find the ideal gift to illuminate relationships and make this festive season truly special.",
          ContactFormName: "Diwali Catalog",
        },
      ];
    return(
        <>
        <Helmet>
            <title>eYantra Diwali Corporate Gifting Ideas</title>
            <meta name="description" content="Browse eYantra’s Diwali catalog for employee gifts, joining kits, onboarding kits, and personalised business items with branded company merchandise."/>
            <meta name="keywords" content="eyantra, diwali catalog, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits, employee gifts, personalised business items, company merchandise"/>
        </Helmet>
            <Ctapage data={CTAContent} />
            <ClinetsLogoSlider/>
           <Whychooseus/>
        </>
    )
}

export default DiwaliCatalog;